// import S from "./styles";
import logo from "./images/teilor-logo.svg";
import "./header.css";
export default function Header() {
  return (
    <div className="HeaderMain">
      <a href={"https://www.teilor.pl/"}>
        <img src={logo} alt=""></img>
      </a>
    </div>
  );
}
